module.exports = new __parcel__URL__("cumulative-flow-diagram.6aa106f9.svg").toString();